import { forwardRef, createElement } from 'react';

function IconLedgerCardTransferredOpeningEntry(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M18.567 12.105a.4.4 0 01.1.309l-.29 2.798 2.434 1.41a.4.4 0 01-.116.737l-2.752.587-.587 2.752a.4.4 0 01-.738.116L15.21 18.38l-2.798.292a.4.4 0 01-.339-.666l1.88-2.092-1.141-2.571a.4.4 0 01.528-.528l2.57 1.141 2.093-1.88a.4.4 0 01.565.03zM4.5 15v4.25a.25.25 0 00.193.243l.057.007H11V21H4.75A1.75 1.75 0 013 19.25V15h1.5zm6.28-1.72l-3 3-.084.073a.75.75 0 01-1.049-1.05l.073-.083 1.718-1.72H2.75a.75.75 0 110-1.5h5.689l-1.72-1.72a.75.75 0 01.977-1.133l.084.073 3 3a.754.754 0 01.092.11l.054.095.035.086.027.103.01.084-.001.121-.017.102-.019.068-.023.06-.035.07-.06.09-.063.071zM19.25 3c.966 0 1.75.784 1.75 1.75V11h-1.5V6h-15v4.5H3V4.75C3 3.784 3.784 3 4.75 3h14.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var LedgerCardTransferredOpeningEntry = /*#__PURE__*/forwardRef(IconLedgerCardTransferredOpeningEntry);

export default LedgerCardTransferredOpeningEntry;
//# sourceMappingURL=LedgerCardTransferredOpeningEntry.js.map
